<h1 align="center">Privacy Policy</h1>

<p>
    <b>Last Updated:</b> November 15, 2016
</p>

<p>
    Thank you for using PayBee.
</p>

<p>
    By using PayBee Services you agree to terms laid out in this Privacy Policy ("Privacy Policy") along with PayBee Terms of Service ("Terms of Service") described at <a target="_blank" href="paybee.io/tos.html">Terms of Service</a>. If you do not agree with any of these terms please do not use PayBee.
</p>
<p>
    You agree to accept this Privacy Policy when you sign up for, access, or use our products, services, content, features, technologies or functions offered on our website and all related sites, applications, and services (collectively, "PayBee Services" or "Services). This Privacy Policy is intended to govern the use of PayBee Services by its users (including, without limitation those who use the PayBee Services in the course of their personal and trade or business) unless otherwise specifically agreed through a contract between the parties.
</p>
<p>
    We may revise or update this Privacy Policy at any time by posting a revised version on our website. The revised version will be effective as of the published latest effective date. In addition, if the revised version includes a substantial or material change, we will provide you with 10 day’s prior notice by posting notice of the change on the "Policy Updates" page of our website. After this 10-day notice period, you will be considered as having expressly consented to all amendments to this Privacy Policy. Continued use of PayBee Services after an update also signifies your acceptance of the revisions.
</p>
<p>
    This Policy does not apply to any website, product or service of any third-party company even if the website links to (or is linked from) our website. PayBee does not operate or control those websites, products or services. Please always review the privacy practices of a company before deciding whether to provide any information.
<p>
<p>
    <b>Collection of Personal Information</b>
</p>
<p>
    We collect the following types of personal information in order to provide you with the use of PayBee Services, and to help us personalize and improve your experience.
</p>
<p>
    <b>Information We Collect Automatically</b>
</p>
<p>
    When you use PayBee Services, we collect information sent to us by your computer, mobile phone or another access device. The information sent to us includes, but is not limited to, the following: data about the pages you access, computer IP address, device ID or unique identifier, device type, geo-location information, computer and connection information, mobile network information, statistics on page views, traffic to and from the sites, referral URL, ad data, and standard web log data and other information. We also collect anonymous information through our use of cookies in some cases.
</p>
<p>
    <b>Information You Provide to Us</b>
</p>
<p>
    We may collect and store any information you provide us when you use PayBee Services, including when you add information on a web form, add or update your account information, during the registration, participate in community discussions, chats, or dispute resolutions, or when you otherwise correspond with us regarding PayBee Services.
</p>
<p>
    <b>Registration and Passwords</b>
</p>

<p>
    When you register with PayBee, we require you to supply personal information including a username and password. By registering or using PayBee Services, you agree to this Privacy Policy and our Terms of Service. You are entirely responsible for maintaining the confidentiality of your password. You agree not to use the account, username, or password of another user at any time, or to disclose your password to any third party. You are solely responsible for any and all use of your account and password.
</p>

<p>
    <b>Information on Transactions and Activities</b>
</p>
<p>
    When you use PayBee Services, we also collect information about your transactions and your activities. In addition, if you open a PayBee account or use PayBee Services, we may collect the following types of personally identifiable information or personal information ("Personal Information"):
</p>
<ul>
    <li>
        Contact information, such as your name, address, phone, email and other similar information
    </li>
    <li>
        Financial information, such as the full bank account numbers and/or credit card numbers that you link to your PayBee account or give us when you use PayBee Services
    </li>
    <li>
        Detailed Personal Information such as your date of birth or national ID number
    </li>
</ul>
<p>
    We may also collect information from or about you from other sources, such as through your contact with us, including our customer support team, the results when you respond to a survey, your interactions with members of the PayBee corporate family or other companies (subject to their privacy policies and applicable law), and from other accounts we have reason to believe you control (whether in part or in whole).
</p>
<p>
    <b>Information from Other Sources</b>
</p>
<p>
    We may also obtain information about you from third parties such as credit bureaus and identity verification services.
</p>
<p>
    You may choose to provide us with access to certain Personal Information stored by third parties such as social media sites (e.g., Facebook and Twitter). The information we may receive varies by site and is controlled by that site. By associating an account managed by a third party with your PayBee account and authorizing PayBee to have access to this information, you agree that PayBee may collect, store and use this information in accordance with this Privacy Policy.
</p>
<p>
    <b>Authentication and Fraud Detection</b>
</p>
<p>
    In order to help protect you from fraud and misuse of your Personal Information, we may collect information about you and your interactions with PayBee Services. We may also evaluate your computer, mobile phone or other access device to identify any malicious software or activity.
</p>
<p>
    <b>Using Your Mobile Device </b>
</p>

<p>
    We may offer you the ability to connect with PayBee Services using a mobile device, either through a mobile application or via a mobile optimized website. The provisions of this Privacy Policy apply to all such mobile access and use of mobile devices.
</p>
<p>
    When you download, use our mobile applications, or access one of our mobile optimized sites, we may receive information about your location and your mobile device, including a unique identifier for your device. We may use this information to provide you with location-based services, such as advertising, search results, and other personalized content.
</p>
<p>
    <b>How We Use the Personal Information We Collect</b>
</p>

<p>
    Our primary purpose in collecting Personal Information is to provide you with a secure, smooth, efficient, and customized experience. We may use your Personal Information to:
</p>
<ul>
    <li>
        Provide PayBee Services and customer support
    </li><li>
    Process transactions and send notices about your transactions
</li><li>
    Verify your identity, including during account creation and password reset processes
</li><li>
    Resolve disputes, collect fees, and troubleshoot problems
</li><li>
    Manage risk, or to detect, prevent, and/or remediate fraud or other potentially prohibited or illegal activities
</li><li>
    Detect, prevent or remediate violations of policies or applicable user agreements
</li><li>
    Improve the PayBee Services by customizing your user experience
</li><li>
    Measure the performance of the PayBee Services and improve their content and layout
</li><li>
    Manage and protect our information technology infrastructure
</li><li>
    Provide targeted marketing and advertising, provide Service update notices, and deliver promotional offers based on your communication preferences
</li><li>
    Contact you at any telephone number, by placing a voice call or through text (SMS) or email messaging, as authorized by our User Agreement
</li><li>
    Perform creditworthiness and solvency checks, compare information for accuracy and verify it with third parties
</li><li>
    Respond to your inquiries and communicate with you through our mailing list
</li>
</ul>
<p>
    We may contact you via electronic means or postal mail to notify you regarding your account, to troubleshoot problems with your account, to resolve a dispute, to collect fees or monies owed, to poll your opinions through surveys or questionnaires, or as otherwise necessary to service your account. Additionally, we may contact you to offer coupons, discounts and promotions, and inform you about PayBee Services and the services of our corporate family. Finally, we may contact you as necessary to enforce our policies, applicable law, or any agreement we may have with you. When contacting you via phone, to reach you as efficiently as possible, and we may use, and you consent to receive, autodialed or prerecorded calls and text messages as used in the industry.  Where applicable and permitted by law, you may decline to receive certain communications.
</p>
<p>
    <b>Marketing</b>
</p>
<p>
    We do not sell or rent your Personal Information to third parties for their marketing purposes without your explicit consent. We may combine your Personal Information with information we collect from other companies and use it to improve and personalize PayBee Services, content, and advertising.  We do not and will not send spam, or sell or rent your email address to third parties. Further, we do not disclose, sell, share, trade or give away a user’s Personal Information to third parties, except as needed for completing payment and billing transactions through the services of Payment Partners.
</p>

<p>
    <b>How We Use Cookies and Similar Technologies</b>
</p>
<p>
    When you access our website or use PayBee Services, we (including companies we work with) may place small data files on your computer or other device. These data files may be cookies, pixel tags, e-tags, "Flash cookies," or other local storage provided by your browser or associated applications (collectively "Cookies"). We use these technologies to recognize you as a customer; customize PayBee Services, content, and advertising, measure promotional effectiveness, help ensure that your account security is not compromised, mitigate risk and prevent fraud, improve our services to you, and to promote trust and safety across our sites and PayBee Services.
</p>
<p>
    You are free to decline our Cookies if your browser or browser add-on permits, unless our Cookies are required to prevent fraud or ensure the security of websites we control. However, declining our Cookies may interfere with your use of our website and PayBee Services.
</p>
<p>
    <b>Do Not Track</b>
</p>
<p>
    Do Not Track (DNT) is an optional browser setting that allows you to express your preferences regarding tracking by advertisers and other third parties. We do not currently respond to DNT signals. We do, however, provide you notice of the tracking by advertisers and other third parties in our Privacy and Cookies policies.
</p>
<p>
    <b>How We Protect and Store Personal Information</b>
</p>
<p>
    Throughout this Privacy Policy, we use the term "Personal Information" to describe information that can be associated or identified with a specific person and can be used to identify that person. We do not consider Personal Information to include information that has been made anonymous so that it does not identify a specific user.
</p>
<p>
    We store and process your Personal Information on our computers in North America (today) and elsewhere (in future) in the world where our facilities are located. We protect your information using physical, technical, and administrative security measures to reduce the risks of loss, misuse, unauthorized access, disclosure and alteration. Some of the safeguards we use are firewalls and data encryption, physical access controls to our data centers, and information access authorization controls.
</p>
<p>
    Currently we don’t store your card numbers and bank account credentials on servers owned by PayBee. This information is securely stored with or financial, infrastructure, and operations partners. Please check partner’s section of this document for policy that is applicable to it.
</p>
<p>
    Security and integrity of our network and systems is a top priority for us, however because the Internet is not 100% secure and the emergence and evolution of new technology, we cannot guarantee our security measures will prevent all third-party interferences from tampering or illegally obtaining your Personal Information. We recommend that you avoid entering sensitive information into any freeform text field and encourage you to change your password often and use a combination of letters, numbers, and characters for your password.
</p>
<p>
    <b>How We Share Personal Information with Other PayBee Users</b>
</p>
<p>
    When transacting with others, we may provide those parties with information about you necessary to complete the transaction, such as your name, account ID, contact details, shipping and billing address, or other information needed to promote the reliability and security of the transaction. If a transaction is held, fails, or is later invalidated, we may also provide details of the unsuccessful transaction. To facilitate dispute resolution, we may provide a payer with the payee’s address so that refunds can be processed.
</p>
<p>
    <b>Third Party Relationships</b>
</p>
<p>
    We work with third parties, including merchant processors and payment partners ("Payment Partners") to enable them to accept or send payments from or to you using PayBee. In doing so, a third party may share information about you with us, such as your email address or mobile phone number, to inform you that a payment has been sent to you or when you attempt to pay a merchant or third party. We use this information to confirm that you are a PayBee customer and that PayBee as a form of payment can be enabled, or to send you notification of payment status. Also, if you request that we validate your status as a PayBee customer with a third party, we will do so. The current Payment Partners used by PayBee are identified at the end of this policy.
</p>
<p>
    <b>Privacy of Minors</b>
</p>
<p>
    PayBee does not promote or offer Services for use by children under the age of 18 ("minors "). We do not knowingly solicit or collect Personal Information from minors, and we will not knowingly link to any third-party website or platform that solicits or collects Personal Information from minors. In keeping with Children Online Privacy Protection Act (COPPA).  We also do not specifically market to children under 13. If you believe that a minor has disclosed Personal Information to us or that we have linked to such a third-party website or platform, please contact us at <u>contact&#64;paybee.io</u>.
</p>

<p>
    <b>How We Share Personal Information with Other Third Parties</b>
</p>
<p>
    We may share your Personal Information we collect from you, including your name, contact details, and transactions and activities, with:
</p>
<ul>
    <li>
        PayBee provide joint content, products, and services (such as registration, transactions and customer support), to help detect and prevent potentially illegal acts and violations of our policies, and to guide decisions about their products, services, and communications. We may use this information to send you marketing communications only if you have requested their services. Financial institutions that we partner with to jointly create and offer a product. These financial institutions may only use this information to market PayBee-related products, unless you have given consent for other uses
    </li>
    <li>
        Credit bureaus and collection agencies to report account information, as permitted by law
    </li>
    <li>
        Banking or Payment Partners as required by credit card association rules for inclusion on their list of terminated merchants (in the event that you meet their criteria which includes having PayBee close your PayBee account due to your breach of the PayBee Terms of Service or this Privacy Policy)
    </li>
    <li>
        Payment Partners for the processing of payment and billing transactions
    </li>
    <li>
        Companies that we plan to merge with or are acquired by. (Should such a combination occur, we would require that the new combined entity follow this Privacy Policy with respect to your Personal Information. If your Personal information could be used contrary to this policy, you will receive prior notice.)
    </li>
    <li>
        Law enforcement, government officials, or other third parties pursuant to a subpoena, court order, or other legal process or requirement applicable to PayBee or one of its affiliates; when we need to do so to comply with law or credit card rules; or when we believe, in our sole discretion, that the disclosure of Personal Information is necessary to prevent physical harm or financial loss, to report suspected illegal activity or to investigate violations of our User Agreement
    </li>
    <li>
        Other unaffiliated third parties, for the following purposes:
        <ul>
            <li>
                Fraud Prevention and Risk Management
            </li>
            <li>
                <u>Customer Service</u>: for customer service purposes, including to help service your accounts or resolve disputes (e.g., billing or transactional)
            </li>
            <li>
                <u>Legal Compliance</u>: to help them comply with anti-money laundering and counter-terrorist financing verification requirements
            </li>
            <li>
                <u>Service Providers</u>: to enable service providers under contract with us to support our business operations, such as fraud prevention, bill collection, marketing, customer service and technology services. Our contracts dictate that these service providers only use your information in connection with the services they perform for us and not for their own benefit.
            </li>
        </ul>
    </li>
    <li>
        Other third parties with your consent or direction to do so
    </li>
    <li>
        Further, we may also release your information when we believe that your information is necessary to enforce our site policies or protect ours or others’ rights, property, or safety
    </li>
</ul>

<p>
    <b>How You Can Access or Change Your Personal Information</b>
</p>
<p>
    You can review and edit your Personal Information at any time by logging into your PayBee account and reviewing your account settings and profile. You can also close your account through the PayBee website. If you close your PayBee account, we will mark your account in our database as "Closed," but may retain Personal Information from your account for a certain period of time and disclose it in a manner consistent with our practices under this Privacy Policy for accounts that are not closed. We also may retain Personal Information from your account to collect any fees owed, resolve disputes, troubleshoot problems, assist with any investigations, prevent fraud, enforce our User Agreement, or take other actions as required or permitted by law.
</p>
<p>
    <b>Data Protection and Privacy</b>
</p>
<p>
    You agree to maintain any data you receive through the Services including any customer data in a secure and confidential manner, and you will only use such data in conjunction with the Services and only as permitted by the Terms of Service and Privacy Policy between us. You agree not use such customer data except for purposes for which you have received express consent from the specific customer for doing so. You affirm that you are now and will continue to be compliant with all applicable laws governing privacy applicable to you. You agree that you are solely responsible for disclosing to customers and obtaining their consent to the effect that their data will be subject to processing the applicable transactions via PayBee networks including the networks of its Payment Partners.
</p>
<p>
    <b>Customer Communications</b>
</p>

<p>
    You affirm that you are solely responsible for keeping your customers/donors informed of the intended or actual use of the donations you received through PayBee Services including keeping accurate records of transactions with your customers.
</p>
<p>
    <b>Enforcement.</b>
</p>

<p>
    PayBee uses a self-assessment approach to assure compliance with this Privacy Policy and periodically verify that our policies are accurate and comprehensive. We encourage you to raise any privacy concerns or direct any questions regarding this Privacy Policy by contacting us at <u>contact&#64;paybee.io</u>, and we will investigate and attempt to resolve any complaints and disputes regarding use and disclosure of Personal Information in accordance with this Privacy Policy and our Terms of Service.
</p>
<p>
    If a complaint or dispute cannot be resolved through our internal process, we agree to dispute resolution using an independent recourse mechanism as a third-party resolution provider.
</p>
<p>
    <b>Fair Information Practices</b>
</p>
<p>
    In the event of a data breach of Personal Information, PayBee will notify all individuals who have been affected within thirty days after we identify it via email.
</p>
<p>
    <b>CAN SPAM Act</b>
</p>

<p>
    If at any time you would like to unsubscribe from receiving future emails, you can email us at: contact&#64;paybee.io and we will promptly remove you from future correspondence except for the limited purposes expressly specified in this Privacy Policy or our Terms of Service.
</p>

<p>
    <b>How You Can Contact Us about Privacy Questions</b>
</p>
<p>
    If you have questions or concerns regarding this Privacy Policy, you should contact us at <u>contact&#64;paybee.io</u>
</p>
<p>
    If at anytime you would like to unsubscribe from receiving future emails, you can email us at contact&#64;paybee.io and we will remove you from all future correspondence.
</p>

<p>
    <b>Payment Partners</b>
</p>
<p>
    To provide you with seamless experience we work with following Payment Partners, you can check our Payment Partner’s relevant policy documents by visiting respective urls.
</p>
<ul>
    <li>
        <b><u>Stripe:</u></b> We use stripe for card and ACH processing of payments. Check out Stripe’s legal documents at following url:
        <ul>
            <li>
                <a target="_blank" href="https://stripe.com/us/privacy">stripe.com/us/privacy</a>
            </li>
            <li>
                <a href="https://stripe.com/us/connect-account/legal">stripe.com/us/connect-account/legal</a>
            </li>
        </ul>
    </li>
    <li>
        <b><u>Plaid:</u></b> We use plaid in conjugation with stripe for instant verification of bank accounts, you can check Plaid legal documents at:
        <ul>
            <li>
                <a target="_blank" href="https://plaid.com/legal/">plaid.com/legal</a>
            </li>
        </ul>
    </li>
</ul>
